export default __webpack_public_path__ + "static/media/two.721a0672.svg";